import React from 'react';
import { X, Clock, AlertCircle, CheckCircle } from 'lucide-react';

// Modal que se muestra ANTES de confirmar un slot on-demand.
// Réplica del `OnDemandExplainerSheetWidget` de la app Flutter.
// El usuario puede aceptar (continuar) o cancelar (elegir otro horario).
const OnDemandExplainerModal = ({ slot, doctor, onAccept, onCancel }) => {
  if (!slot) return null;

  const hourLabel = slot.hourStart
    ? (slot.hourStop ? `${slot.hourStart} - ${slot.hourStop}` : slot.hourStart)
    : (slot.init ? (slot.end ? `${slot.init} - ${slot.end}` : slot.init) : '');

  return (
    <div className="fixed inset-0 bg-black/50 z-[60] flex items-center justify-center p-4 overflow-y-auto animate-fadeIn">
      <div className="bg-white rounded-card shadow-elevated max-w-md w-full overflow-hidden">
        <div className="relative p-6 pb-4 bg-amber-pill/20">
          <button
            onClick={onCancel}
            className="absolute top-4 right-4 text-text-secondary hover:text-text-primary transition-colors"
            aria-label="Cerrar"
          >
            <X size={22} />
          </button>
          <div className="flex items-start gap-3">
            <div className="p-3 bg-amber-pill text-amber-deep rounded-input">
              <AlertCircle size={26} />
            </div>
            <div>
              <h3 className="text-lg md:text-xl font-bold text-text-primary leading-tight">
                Este horario es bajo confirmación
              </h3>
              <p className="text-sm text-text-secondary mt-1">
                {doctor?.name
                  ? `${doctor.name}${doctor.last_name ? ' ' + doctor.last_name : ''} debe aceptar tu solicitud antes de quedar agendada.`
                  : 'La doctora debe aceptar tu solicitud antes de que quede agendada.'}
              </p>
            </div>
          </div>
        </div>

        <div className="p-6 pt-5 space-y-4">
          {hourLabel && (
            <div className="flex items-center gap-3 px-4 py-3 bg-amber-pill/20 rounded-input">
              <Clock size={18} className="text-amber-deep" />
              <div className="text-sm">
                <span className="font-semibold text-text-primary">Horario solicitado:</span>{' '}
                <span className="text-text-secondary">{hourLabel}</span>
              </div>
            </div>
          )}

          <ul className="space-y-2.5 text-sm text-text-secondary">
            <li className="flex items-start gap-2">
              <CheckCircle size={16} className="text-daisies mt-0.5 flex-shrink-0" />
              <span>La doctora tiene <strong className="text-text-primary">24 horas</strong> para aceptar o rechazar.</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle size={16} className="text-daisies mt-0.5 flex-shrink-0" />
              <span>Recibirás una notificación en cuanto sea respondida.</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle size={16} className="text-daisies mt-0.5 flex-shrink-0" />
              <span>Mientras tanto, tu cita aparece como <em>pendiente de confirmación</em>.</span>
            </li>
          </ul>

          <div className="flex flex-col gap-3 pt-2">
            <button
              onClick={onAccept}
              className="press-scale w-full px-6 py-3 bg-daisies text-white rounded-full font-semibold hover:bg-daisies-hover transition-all"
            >
              Entendido, continuar
            </button>
            <button
              onClick={onCancel}
              className="press-scale w-full px-6 py-2.5 text-text-secondary rounded-full font-semibold hover:bg-surface transition-all"
            >
              Elegir otro horario
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnDemandExplainerModal;
